import React, { useState, useEffect } from 'react';
import { updatePartnerAction, createPartnerAction, deletePartnerAction, getPartnersAction } from "../../../actions/partnersActions";
import { API_URL } from '../../../actions';

import TextEditor from '../../partials/TextEditor';
import edit from '../../../assets/images/icons/edit.svg';
import remove from '../../../assets/images/icons/remove.svg';
import close from '../../../assets/images/icons/close.svg';
import save from '../../../assets/images/icons/save.svg';

export default function Partner({ partnerValue, setRemoveAction, index, theme, lang, dispatch, openSelectPicture, openSelectPartnerVideo, context, companyId }) {

  const [partner, setPartner] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [text, setText] = useState("");

  useEffect(() => {
    setPartner({ ...partner, ...partnerValue });
    if (partnerValue?.text) {
      setText(partnerValue.text);
    }
    // eslint-disable-next-line
  }, [partnerValue]);

  useEffect(() => {
    if (!partnerValue?._id) {
      setIsEdit(true);
    }
    // eslint-disable-next-line
  }, [partnerValue]);

  function renderPartnerImg() {
    if (partner && partner.picture && context.medias.mediasList) {
      const imgFound = context.medias.mediasList.find(item => item._id === partner.picture);
      if (imgFound) {
        return <img src={API_URL + '/' + imgFound.path} alt="partner" className={isEdit ? "img-small" : "circle"} />;
      } else if (partner.picture?.path) {
        return <img src={API_URL + '/' + partner.picture.path} alt="partner" className={isEdit ? "img-small" : "circle"} />;
      }
    }
  }

  function renderPartnerVideo() {
    if (partner && partner.video && context.medias.mediasList) {
      const videoFound = context.medias.mediasList.find(item => item._id === partner.video);
      if (videoFound) {
        return (
          <video controls="controls" className="img-large">
            <source src={API_URL + '/' + videoFound.path} />
          </video>
        );
      } else if (partner.video?.path) {
        return (
          <video controls="controls">
            <source src={API_URL + '/' + partner.video.path} />
          </video>
        );
      }
    }
  }

  async function closePartner() {
    let updatedPartner = JSON.parse(JSON.stringify(partner));
    if (text) updatedPartner.text = text;
    if (partner._id) {
      await updatePartnerAction(dispatch, updatedPartner);
    } else {
      updatedPartner.company = companyId;
      updatedPartner.lang = lang;
      await createPartnerAction(dispatch, updatedPartner);
    }
    getPartnersAction(dispatch, lang);
    setIsEdit(false);
  }

  function renderEdit() {
    return (
      <>
        <div className="btn-close-row">
          <button type="button" style={{ width: 30 }} onClick={() => closePartner()}>
            <img src={save} alt="save" />
          </button>
          <button onClick={() => setIsEdit(false)}>
            <img src={close} alt="close" />
          </button>
        </div>

        <label htmlFor={`partner-title-${index}`}>Nom</label>
        <input
          id={`partner-title-${index}`}
          name="title"
          style={{ marginBottom: 10 }}
          onChange={(e) => setPartner({ ...partner, title: e.target.value })}
          defaultValue={partner?.title || ""}
        />

        <label htmlFor={`partner-function-${index}`}>Fonction / Rôle</label>
        <input
          id={`partner-function-${index}`}
          name="function"
          style={{ marginBottom: 10 }}
          onChange={(e) => setPartner({ ...partner, function: e.target.value })}
          defaultValue={partner?.function || ""}
        />

        <label>Description</label>
        <TextEditor
          key={`partner-editor-${index}-${partner._id || new Date()}`}
          value={partner?.text}
          onChange={newContent => setText(newContent.replace(/(<p>)/gi, "").replaceAll("<br>", "").replaceAll("</p>", "</br></br>"))}
        />

        <label>Photo du partenaire <span className={`${theme}-color required`}>*</span><br /><span className="note">minimum 800 x 1000 px</span></label>
        <div className="btn-container">
          <button
            type="button"
            className="btn grey"
            style={{ marginRight: 20 }}
            onClick={() => openSelectPicture(index, "partnerPicture")}
          >
            Parcourir
          </button>
          {partner?.picture &&
            <button
              type="button"
              className="btn grey bold"
              onClick={() => setRemoveAction({ function: () => setPartner({ ...partner, picture: null }) })}
            >
              Supprimer la photo
            </button>
          }
        </div>
        <div>{renderPartnerImg()}</div>

        <label>Vidéo du partenaire<br /><span className="note">minimum 1920 x 1080 px</span></label>
        <div className="btn-container">
          <button
            type="button"
            className="btn grey bold"
            style={{ marginRight: 20 }}
            onClick={() => openSelectPartnerVideo(index)}
          >
            Parcourir
          </button>
          {partner?.video &&
            <button
              type="button"
              className="btn grey bold"
              onClick={() => setRemoveAction({ function: () => setPartner({ ...partner, video: null }) })}
            >
              Supprimer
            </button>
          }
        </div>
        <div>{renderPartnerVideo()}</div>
      </>
    );
  }

  function renderRow() {
    return (
      <>
        {partner?._id &&
          <>
            <div className="name">
              {partner.picture ? renderPartnerImg() : <div className="circle"></div>}
              <p className="bold">{partner.title} <span className="text-grey"> / {partner.function}</span></p>
            </div>
            <div className="actions">
              <button type="button" onClick={() => setIsEdit(true)}>
                <img src={edit} alt="edit" />
              </button>
              <button
                type="button"
                onClick={() => setRemoveAction({ function: () => deletePartnerAction(dispatch, partner._id) })}
              >
                <img src={remove} alt="remove" />
              </button>
            </div>
          </>
        }
      </>
    );
  }

  return (
    <div id={`partner${index}`} className={`talent ${!isEdit ? "list-item row" : "edit"}`}>
      {isEdit ? renderEdit() : renderRow()}
    </div>
  );
}
